
import MenuSection from './MenuSection';
import { useSearch } from '../SearchContext';
import SubCategoryItems from './SubCategoryItems';

import React, {Suspense,lazy,useEffect,useRef, useState}from 'react';

function SearchSection(props) {
    const{searchData,handleSearchChange, setSearchData, filter, handleFilterChange, 
         isAllSelected,searchAllCategories,
         setSearchAllCategories}= useSearch ();
         const cart = props.cart;
         //const [searchAllCategories, setSearchAllCategories] = useState(false);
        
    return (
        <div className="container p-0 pt-2 sticky-top " style={{zIndex: 999}} id="searchboxSection">
        <div className="p-1 mt-n3 rounded position-relative" style={{ backgroundColor: '#f8f9fa' }}>
          <div className="input-group mt-1 mb-1 rounded shadow-sm overflow-hidden">
            <input
              id="searchbox"
              type="search"
              className="shadow-none border-0 form-control"
              onChange={handleSearchChange}
              placeholder="Search"
              value={searchData}
            />
          </div>
      
          
          {searchData && (
            <div className="d-flex align-items-center gap-2" style={{ fontSize: '16px' }}>
             <span style={{ userSelect: 'none', marginRight: '8px' }}>
  All Category
</span>

              <div
                onClick={() => setSearchAllCategories(prev => !prev)}
                style={{
                  width: '40px',
                  height: '22px',
                  backgroundColor: searchAllCategories ? 'grey' : '#ccc',
                  borderRadius: '999px',
                  position: 'relative',
                  cursor: 'pointer',
                  transition: 'background-color 0.3s'
                }}
              >
                <div
                  style={{
                    width: '17px',
                    height: '17px',
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    position: 'absolute',
                    top: '2px',
                    left: searchAllCategories ? '22px' : '2px',
                    transition: 'left 0.3s'
                  }}
                />
              </div>
            </div>
          )}
        
      

                    {/*<SubCategoryItems cart={cart} recommendedItemLists={props.subCategories} />*/}
          


            </div>
          
          
            
        </div>
    );
}

export default SearchSection;
